module.exports = __webpack_public_path__ + "pc/img/writer_pc_64.fc09c560.png";